import { AlertTriangle, ClipboardList, Network } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { StatusBadge } from "../components/StatusBadge";
import { usePortal } from "../context/PortalContext";
import { DIMENSION_LABELS, formatDate } from "../lib/format";

export function ProgressPage() {
  const { track, practice } = usePortal();
  if (!track) return <div className="loading-state">正在读取能力证据</div>;
  return (
    <>
      <PageHeading number="04" title="能力进度" description="能力状态来自可检查证据。高风险判断即使通过 AI 练习，也要保持暂定，直到确定性程序或合格外部人员验证。" />
      <section className="progress-principle">
        <div><strong>{track.summary.evidence_started_count}</strong><span>已有证据</span></div>
        <div><strong>{track.summary.mastered_count}</strong><span>完成掌握</span></div>
        <div><strong>{track.summary.passed_assessment_count}</strong><span>通过测评</span></div>
        <div><strong>{practice?.pending_reviews || 0}</strong><span>等待复核</span></div>
      </section>
      <div className="competency-spine">
        {track.competencies.map((competency, index) => (
          <article className="competency-row" key={competency.id}>
            <div className="competency-index">{String(index + 1).padStart(2, "0")}</div>
            <div className="competency-name"><h2>{competency.name}</h2><code>{competency.id}</code><p>{competency.prerequisite_names.length ? `前置：${competency.prerequisite_names.join(" / ")}` : "起点能力"}</p></div>
            <div className="competency-criterion"><p>{competency.criteria}</p>{competency.risk === "high" && <span><AlertTriangle size={14} />高风险能力</span>}</div>
            <div className="dimension-grid">
              {Object.entries(competency.dimensions).map(([key, value]) => <div key={key}><span>{DIMENSION_LABELS[key] || key}</span><StatusBadge status={value.status} />{value.next_review && <small>{formatDate(value.next_review)}</small>}</div>)}
            </div>
            <StatusBadge status={competency.status} />
          </article>
        ))}
      </div>
      <section className="section-block">
        <div className="section-title-row"><div><span className="section-number">04.1</span><h2>掌握规则</h2></div><Network size={22} /></div>
        <div className="rule-grid">
          <div><strong>85%</strong><span>默认通过门槛，且不能出现关键错误</span></div>
          <div><strong>2 次</strong><span>每个维度需要两次未见、带证据的通过</span></div>
          <div><strong>3 天</strong><span>两次通过至少间隔三天，用于检验保持</span></div>
          <div><strong>外部</strong><span>高风险能力需要确定性系统、专家或真人验证</span></div>
        </div>
      </section>
      <section className="section-block">
        <div className="section-title-row"><div><span className="section-number">04.2</span><h2>测评记录</h2></div><ClipboardList size={22} /></div>
        <div className="assessment-table">{track.assessments.map((assessment) => <div className="assessment-row" key={assessment.id}><strong className={assessment.passed ? "score-pass" : "score-fail"}>{assessment.score.toFixed(0)}</strong><div><b>{assessment.competency_name}</b><span>{DIMENSION_LABELS[assessment.dimension]} · {formatDate(assessment.occurred_at, true)}</span></div><p>{assessment.notes}</p><span className={`result-label ${assessment.passed ? "pass" : "fail"}`}>{assessment.critical_error ? "关键错误" : assessment.passed ? "通过" : "未通过"}</span></div>)}</div>
      </section>
    </>
  );
}
